module.exports = __webpack_public_path__ + "img/sangforlogo-small.91a50e4d.png";